import { useState } from 'react';
import { Link } from 'react-router';
import { useLocale } from '@orbit-mind/engine-react';
import { useAccount } from './useAccount';
import { deleteAccount } from './api';
import { AccountControl } from './AccountControl';
import { Button } from '../ui/controls';

export function DeleteAccountPage(): React.JSX.Element {
  const { state, endSession, refresh } = useAccount();
  const { text: t } = useLocale();
  const [confirmation, setConfirmation] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [done, setDone] = useState(false);
  return (
    <main className="bg-surface text-ink mx-auto min-h-screen max-w-xl space-y-5 p-6">
      <Link to="/">← Orbit Mind</Link>
      <h1 className="text-2xl font-semibold">{t('Delete account', 'Excluir conta')}</h1>
      <p>
        {t(
          'Export your maps before continuing. This permanently removes your account, cloud maps, attachments, shared links and feedback. Sessions end immediately; server cleanup runs in the background and may take multiple hours. Backups expire under the retention policy. Local copies on your devices are separate: clear app/browser data to remove them.',
          'Exporte seus mapas antes de continuar. Isso exclui permanentemente sua conta, mapas na nuvem, anexos, links compartilhados e feedback. As sessões terminam imediatamente; a limpeza do servidor ocorre em segundo plano e pode levar várias horas. Backups expiram conforme a política de retenção. Cópias locais nos seus dispositivos são separadas: limpe os dados do app/navegador para removê-las.',
        )}
      </p>
      {done ? (
        <p role="status">
          {t(
            'Deletion requested. Your sessions have ended.',
            'Exclusão solicitada. Suas sessões foram encerradas.',
          )}
        </p>
      ) : state.status === 'signed-in' ? (
        <form
          className="space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            setBusy(true);
            setMessage('');
            void deleteAccount(state.user.id, confirmation, state.user.firebasePassword ? password : undefined).then((result) => {
              setPassword('');
              setBusy(false);
              if (result.ok) {
                setDone(true);
                refresh();
              } else setMessage(result.error.message);
            });
          }}
        >
          <label className="block">
            {t('Type your account email to confirm', 'Digite o e-mail da conta para confirmar')}:{' '}
            {state.user.email}
            <input
              autoComplete="off"
              value={confirmation}
              onChange={(event) => {
                setConfirmation(event.target.value);
              }}
              className="border-edge mt-2 w-full rounded-lg border p-3"
            />
          </label>
          {state.user.firebasePassword === true && <label className="grid gap-2">{t('Confirm your password', 'Confirme sua senha')}<input type="password" required autoComplete="current-password" maxLength={128} value={password} onChange={(event) => { setPassword(event.target.value); }} className="border-edge bg-surface min-h-12 rounded-lg border p-3" /></label>}
          <Button type="submit" disabled={busy || confirmation !== state.user.email || (state.user.firebasePassword === true && !password)}>
            {t('Permanently delete my account', 'Excluir minha conta permanentemente')}
          </Button>
        </form>
      ) : (
        <>
          <p>
            {t(
              'Sign in to confirm which account to delete.',
              'Entre para confirmar qual conta excluir.',
            )}
          </p>
          <AccountControl
            state={state}
            onSignOut={endSession}
            onRefresh={refresh}
            returnTo="/delete-account"
          />
        </>
      )}
      {message !== '' && <p role="alert">{message}</p>}
    </main>
  );
}
